exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#service-list-container {\n  position: absolute;\n  top: 75px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: white;\n  overflow-y: scroll;\n}\ndiv#service-list-container div.services-grid-container {\n  max-width: 1200px;\n  margin: auto;\n  margin-top: 35px;\n}\ndiv#service-list-container div.services-grid-container div.no-results {\n  margin-top: 20px;\n  text-align: center;\n}\ndiv#service-list-container div.services-grid-container div.no-results span {\n  font-size: 20px;\n}\n\n/* Small only */\n@media screen and (max-width: 39.9375em) {\ndiv.services-grid-container {\n    height: inherit;\n}\n}", ""]);

// exports
